import { Component, ChangeDetectionStrategy, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { navigateFAD, ProviderFromFAD } from '../../models/v2/search';
import { ConfigurationKey } from 'src/app/core/models/configuration-key';
import { InstanceService } from '@commonspirit/ngx-instance';
import { EnvironmentService } from '@commonspirit/ngx-environment';
import { environment } from '../../../../environments/environment';
import { CjaTagService } from 'src/app/shared/services/cja-tag/cja-tag.service';
import { EnvValue } from '@commonspirit/ngx-environment/lib/models/key-value-pair';
import { EmbedSource, getEmbedSource } from 'src/app/core/util/root-element';

@Component({
  selector: 'fal-provider-card',
  templateUrl: './provider-card.component.html',
  styleUrls: ['./provider-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProviderCardComponent implements OnInit {
  @Input() provider: ProviderFromFAD;
  @Input() locationName!: string;
  @Input() locationId!: string | number;
  @Output() navigateFADProvider = new EventEmitter<navigateFAD>();
  marketCodeImage!: { link: string }[] | undefined;
  showFadComponent = false;
  deployUrl: string = environment.deployUrl;
  initialNaviagteModel: navigateFAD = {
    npi: '',
    locationId: '',
    locationName: '',
    city: '',
    state: ''
  };
  enableBlockIT = false;
  navigateFADModel: navigateFAD = this.initialNaviagteModel;
  isCerner = false;
  constructor(public service: InstanceService, private environmentService: EnvironmentService, private cjaTagService: CjaTagService) {
    const enableBlockITForEnvironment: EnvValue | undefined = this.environmentService.getSetting('enableBlockIT')?.value;
    if (typeof enableBlockITForEnvironment === 'boolean') {
      this.enableBlockIT = enableBlockITForEnvironment;
    }
  }

  ngOnInit(): void {
    this.marketCodeImage = this.getLink(ConfigurationKey.MarketCodeImage);
    this.isCerner = getEmbedSource() === EmbedSource.CERNER ? true : false;
  }
  providerNavigate(npi: string): void {
    this.navigateFADModel.npi = npi;
    sessionStorage.setItem('FAL_Provider_redirectto-fad', 'true');
    window.sessionStorage.setItem('falLocationDetailsParam', 'true');
    this.navigateFADProvider.emit(this.navigateFADModel);
  }
  getLink(key: string): { link: string }[] | undefined {
    const link = (this.service.getConfiguration(key)?.value as { link: string }[]) ?? undefined;
    if (!link) return;
    return link;
  }

  getImagePath(): string | undefined {
    if (this.provider?.imageSmall) {
      return this.provider.imageSmall;
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.getFallbackImage();
  }

  getFallbackImage(): any {
    if (this.provider.gender === 'F') {
      return this.environmentService.getEndpoint('fadFemaleImageUrl')?.url;
    } else {
      return this.environmentService.getEndpoint('fadMaleImageUrl')?.url;
    }
  }

  viewProfileClick(): void {
    this.cjaTagService.logCJAEvent({
      event: 'customEvent',
      event_name: 'search_schedule:provider profile click',
      event_category: 'search and schedule',
      event_action: 'provider profile click',
      event_label: '',
      event_doctor_name: this.provider.displayFullName, //Doctor name if avail.
      event_doctor_npi: this.provider.npi, //Doctor NPI number if avail.
      patientEngagement: 'true',
      visitor_loginStatus: 'false' //if avail
    });
    if (getEmbedSource() === EmbedSource.CERNER) {
      this.fadLocationNavigate();
    } else {
      this.providerNavigate(this.enableBlockIT ? this.provider.slug : this.provider.npi);
    }
  }

  fadLocationNavigate(): void {
    const providerDetails = `/${this.provider.npi}-${this.provider.firstName}-${this.provider.lastName}`;
    const embedSource = getEmbedSource() ?? '';
    const fadPageUrl = this.getSourceInstanceConfiguration(ConfigurationKey.FadPage, embedSource)?.value as { link: string };
    const redirectURL = this.enableBlockIT
      ? `${fadPageUrl.link}${this.provider.slug}?FALredirecttoFAD=true&FALlocation=${this.locationId}`
      : `${fadPageUrl.link}${providerDetails}?FALredirecttoFAD=true&FALlocation=${this.locationName
          ?.toUrlFriendly()
          ?.stripPeriod()
          ?.condenseDashes()
          .removeSpecialCharacters()
          .sanitizeHyphens()}-${this.locationId}`;
    sessionStorage.setItem('toFAD', 'true'); //need it to go back to location results.
    window.open(redirectURL, '_self');
  }

  getSourceInstanceConfiguration(key: string, source: string): { embedSource: string; value: EnvValue } | undefined {
    const returnValue =
      (this.service.getConfiguration(key)?.value as {
        embedSource: string;
        value: EnvValue;
      }[]) ?? [];
    return returnValue.find((x) => x.embedSource === source);
  }
}
